import React from "react";
import { Grid, Typography, Card } from "@mui/material";
import { Icon } from "@iconify/react";
import Heading from "./Heading";

const Skills = () => {
  const stack = [
    { name: "HTML", icon: "iconoir:html5" },
    { name: "CSS", icon: "iconoir:css3" },
    { name: "JavaScript", icon: "teenyicons:javascript-outline" },
    { name: "React", icon: "akar-icons:react-fill" },
    { name: "Redux", icon: "akar-icons:redux-fill" },
    { name: "Next.js", icon: "vscode-icons:file-type-next" },
    { name: "Typescript", icon: "file-icons:typescript" },
    { name: "Node.js", icon: "fontisto:nodejs" },
    { name: "Express", icon: "simple-icons:express" },
    { name: "MongoDB", icon: "teenyicons:mongodb-outline" },

  ];

  // const learning = [
  //   { name: "Typescript", icon: "file-icons:typescript" },
  // ];
  return (
    <article>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginBottom="70px"
        id="skills"
      >
        <Heading title="Skills" subtitle="My powers" />
        <Typography
          textAlign="center"
          sx={{ fontSize: "1.25rem", marginBottom: "2rem" }}
        >
          The tools and technologies I use:
        </Typography>
        <Grid
          container
          spacing={3}
          width={{ xs: "100%", md: "40%" }}
          justifyContent="center"
        >
          {stack.map((item, index) => (
            <Grid item md={3} key={index}>
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "120px",
                  height: "120px",
                  textAlign: "center",
                  gap: "10px",
                  padding: "5px",
                }}
              >
                <Icon
                  icon={item.icon}
                  inline={true}
                  style={{ fontSize: "2rem" }}
                />
                <Typography sx={{ color: "#9b63ff" }}>{item.name}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
{/*         <Typography
          variant="h5"
          component="div"
          textAlign="center"
          color="primary"
          sx={{ padding: "2rem", marginTop: "2rem" }}
        >
          Learning
        </Typography>
        <Typography
          textAlign="center"
          width="80%"
          sx={{ fontSize: "1.25rem", marginBottom: "2rem" }}
        >
          I am currently expanding my skills by learning:
        </Typography>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "40%" }}
        >
          {learning.map((item, index) => (
            <Grid item md={3} key={index}>
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "120px",
                  height: "120px",
                  textAlign: "center",
                  gap: "10px",
                  padding: "5px",
                }}
              >
                <Icon
                  icon={item.icon}
                  inline={true}
                  style={{ fontSize: "2rem" }}
                />
                <Typography sx={{ color: "#9b63ff" }}>{item.name}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid> */}
      </Grid>
    </article>
  );
};

export default Skills;
